module.exports = __webpack_public_path__ + "media/newmessage.2a68856f.mp3";